import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import { Container, Row, Col } from 'react-grid-system'
import moment from 'moment-timezone'

import { LoadingBoxList } from 'components/LoadingSpinner'

import EditButton from 'components/buttons/EditButton'
import DeleteButton from 'components/buttons/DeleteButton'

import styles from './index.css'

@withRouter
export default class EmployeesList extends React.Component {
  
  static propTypes = {
    loading  : PropTypes.bool,
    entities : PropTypes.arrayOf(PropTypes.object),
    onDelete : PropTypes.func,
    onEdit   : PropTypes.func,
    pageControl: PropTypes.any
  }

  static defaultProps = {
    loading : false,
    onEdit : (id) => {},
    onDelete : (id) => {}
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Container className={styles.List}>
        <Row className={styles.Header}>
          <Col xs={5}>
            <h1>Name</h1>
          </Col>
          <Col xs={2}>
            <h1>ID Code</h1>
          </Col>
          <Col xs={5} style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
            {this.props.pageControl}
          </Col>
        </Row>
        {
          this.props.loading && <LoadingBoxList />
        }
        {
          !this.props.loading &&
          (this.props.entities || []).map(({ id, name, id_code }) =>
            <Row className={styles.Row} key={id}>
              <Col xs={5}>
                {name}
              </Col>
              <Col xs={2}>
                {id_code}
              </Col>
              <Col xs={5} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <DeleteButton onClick={() => this.props.onDelete(id)} />
                <EditButton onClick={() => this.props.onEdit(id)} />
              </Col>
            </Row>
          )
        }
      </Container>
    )
  }

}



// WEBPACK FOOTER //
// ./src/lists/EmployeesList/index.jsx